import { Routes } from '@angular/router';
import { PalletCorrectionService } from './services/pallet-correction.service';
import { PalletCorrectionRepository } from './repositories/pallet-correction.repository';

export const palettenkorrekturRoutes: Routes = [
  {
    path: 'palettenkorrektur',
    providers: [PalletCorrectionRepository, PalletCorrectionService],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/palettenkorrektur/palettenkorrektur.component'),
      },
    ],
  },
];
